import { faRefresh } from '@fortawesome/free-solid-svg-icons/faRefresh';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Button } from '../../../components/Button';
import { Flex } from '../../../components/Flex';
import { CreateAtiraLinkDto } from '../../../model/atira-link/dto/CreateAtiraLinkDto';
import { CreateAtiraLinkStylesDto } from '../../../model/atira-link/dto/CreateAtiraLinkStylesDto';
import { AtiraLinkStylesBackgroundMode } from '../../../model/atira-link/types/AtiraLinkStylesBackgroundMode.enum';
import { Spacing } from '../../../theme/Spacing';
import { AtiraLinkStyleBackgroundImage } from '../components/style-tab/AtiraLinkStyleBackgroundImage';
import { AtiraLinkStyleButtons } from '../components/style-tab/AtiraLinkStyleButtons';
import { AtiraLinkStyleImage } from '../components/style-tab/AtiraLinkStyleImage';

const Container = styled(Flex)`
  background-color: ${({ theme }) => theme.transparent};
  z-index: 100;
  flex-direction: column;
  flex: 1;
  gap: ${Spacing.l};
`;

const ResetButton = styled(Button)`
  margin-bottom: ${Spacing.m};
  width: fit-content;

  &:hover {
    background-color: ${({ theme }) => theme.mainHover};
  }
`;

export const AtiraLinkDesignTab: React.FC = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'atiraLink.create.design',
  });
  const { setValue } = useFormContext<CreateAtiraLinkDto>();

  const handleReset = () => {
    const defaultStyleValues: CreateAtiraLinkStylesDto = {
      backgroundImage: null,
      button: {
        backgroundColor: undefined,
        borderColor: undefined,
        borderStyle: undefined,
        borderWidth: undefined,
        borderRadius: undefined,
      },
      image: {
        borderColor: undefined,
        borderStyle: undefined,
        borderWidth: undefined,
        borderRadius: undefined,
      },
      background: {
        color: undefined,
        backgroundImagePosition: undefined,
        backgroundImageSize: undefined,
        backgroundMode: AtiraLinkStylesBackgroundMode.COLOR,
      },
    };

    setValue('styles', defaultStyleValues);
  };

  return (
    <Container>
      <AtiraLinkStyleButtons />
      <AtiraLinkStyleImage />
      <AtiraLinkStyleBackgroundImage />

      <ResetButton onClick={handleReset} icon={faRefresh}>
        {t('reset')}
      </ResetButton>
    </Container>
  );
};
